import React, { useEffect, useRef } from 'react';
import { formatNumber2 } from '../../../utils/currencyFormat';

const c3 = window.c3;

export const ChartSection = ({ data, loading, filters }) => {
    const chartRef = useRef(null);
    const chartInstance = useRef(null);

    useEffect(() => {
        if (!chartRef.current) return;
        if (loading || !data || data.length === 0) {
            if (chartInstance.current) {
                try {
                    chartInstance.current.destroy();
                } catch (e) {
                    console.error("Lỗi khi hủy biểu đồ C3:", e);
                }
                chartInstance.current = null;
            }
            return;
        }

        const thangData = ['Tháng', ...data.map(item => item.Thang)];
        const tongThuData = ['Tổng Thu', ...data.map(item => item.TongThu)];
        const chartColumns = [thangData, tongThuData];

        chartInstance.current = c3.generate({
            bindto: chartRef.current,
            data: {
                x: 'Tháng',
                columns: chartColumns,
                type: 'bar',
            },
            axis: {
                x: { type: 'category' },
                y: {
                    label: { text: 'Số tiền (VNĐ)', position: 'outer-middle' },
                    tick: {
                        format: formatNumber2
                    }
                }
            },
            tooltip: {
                format: {
                    value: formatNumber2
                }
            },
            color: { pattern: ['#00B69B'] }
        });

        return () => {
            if (chartInstance.current) {
                try {
                    chartInstance.current.destroy();
                } catch (e) {
                    console.error("Lỗi khi hủy biểu đồ C3:", e);
                }
                chartInstance.current = null;
            }
        };
    }, [data, loading]);
    let title = "Biểu đồ thống kê toàn thời gian";
    if (filters.dtFrom && filters.dtTo) {
        title = `Biểu đồ thống kê từ ${filters.dtFrom} đến ${filters.dtTo}`;
    } else if (filters.dtFrom) {
        title = `Biểu đồ thống kê từ ${filters.dtFrom}`;
    } else if (filters.dtTo) {
        title = `Biểu đồ thống kê đến ${filters.dtTo}`;
    }
    return (
        <div style={{ height: 400, display: 'flex', flexDirection: 'column' }} className="p-2">

            <h4 className="interest-rate-title" style={{ flexShrink: 0 }}>
                {title}
            </h4>

            <div style={{ flex: 1, position: 'relative', width: '`100%' }}>
                {loading && (
                    <div
                        className="d-flex justify-content-center align-items-center"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(255, 255, 255, 0.5)',
                            zIndex: 2
                        }}
                    >
                        <div className="spinner-border text-primary" role="status"></div>
                    </div>
                )}
                <div
                    ref={chartRef}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        opacity: loading ? 0.5 : 1,
                        zIndex: 1
                    }}
                />
            </div>
        </div>
    );
};